function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { arrayEqual, clamp, isNumber, isString, lastItem } from '@okee-uikit/react-utils';
import { useConst, useConstCallback, useRefCallback } from '@okee-uikit/react-hooks';
import { useTableColumns } from '../col-query/column-info';

function useMutationObserver(targetRef, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var refCallback = useRefCallback(callback);
  var attributeFilter = options.attributeFilter,
      attributeOldValue = options.attributeOldValue,
      attributes = options.attributes,
      characterData = options.characterData,
      characterDataOldValue = options.characterDataOldValue,
      childList = options.childList,
      subtree = options.subtree;
  var observerRef = useRef();
  useEffect(function () {
    var _a, _b;

    if (!observerRef.current) {
      observerRef.current = new MutationObserver(refCallback);
    }

    var target = targetRef.current;

    if (target) {
      (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
      (_b = observerRef.current) === null || _b === void 0 ? void 0 : _b.observe(target, {
        attributeFilter: attributeFilter,
        attributeOldValue: attributeOldValue,
        attributes: attributes,
        characterData: characterData,
        characterDataOldValue: characterDataOldValue,
        childList: childList,
        subtree: subtree
      });
    }

    return function () {
      var _a;

      return (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
    };
  }, [targetRef.current, attributeFilter, attributeOldValue, attributes, characterData, characterDataOldValue, childList, subtree]);
}

function useOffsetSize(ref) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    offsetWidth: 0,
    offsetHeight: 0,
    clientWidth: 0,
    clientHeight: 0,
    scrollBarWidth: 0
  };
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  var updateSize = useConstCallback(function () {
    setSize(function (pre) {
      if (ref.current) {
        var _ref$current = ref.current,
            offsetWidth = _ref$current.offsetWidth,
            offsetHeight = _ref$current.offsetHeight,
            clientWidth = _ref$current.clientWidth,
            clientHeight = _ref$current.clientHeight;

        if (offsetWidth !== pre.offsetWidth || offsetHeight !== pre.offsetHeight || pre.clientWidth !== clientWidth || pre.clientHeight !== clientHeight) {
          return {
            offsetWidth: offsetWidth,
            offsetHeight: offsetHeight,
            clientWidth: clientWidth,
            clientHeight: clientHeight,
            scrollBarWidth: offsetWidth - clientWidth
          };
        }
      }

      return pre;
    });
  });
  useEffect(function () {
    window.addEventListener('resize', updateSize);
    return function () {
      return window.removeEventListener('resize', updateSize);
    };
  });
  useEffect(function () {
    updateSize();
  }, [ref.current].concat(_toConsumableArray(deps)));
  useMutationObserver(ref, function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        updateSize();
      }
    });
  }, {
    attributes: true
  });
  return size;
}

export function useContainerSizeAndScroll() {
  var deps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var ref = useRef(null);
  var size = useOffsetSize(ref, undefined, deps);

  var _useState3 = useState([true, true]),
      _useState4 = _slicedToArray(_useState3, 2),
      _useState4$ = _slicedToArray(_useState4[0], 2),
      scrollStart = _useState4$[0],
      scrollEnd = _useState4$[1],
      setIndicates = _useState4[1];

  var updateScroll = useConstCallback(function () {
    var elem = ref.current;

    if (elem) {
      var clientWidth = elem.clientWidth,
          scrollLeft = elem.scrollLeft,
          scrollWidth = elem.scrollWidth;
      var scroll = Math.abs(scrollLeft);
      var start = scroll === 0;
      var end = scroll >= scrollWidth - clientWidth - 1;
      setIndicates(function (pre) {
        var _pre = _slicedToArray(pre, 2),
            preStart = _pre[0],
            preEnd = _pre[1];

        if (preStart !== start || preEnd !== end) {
          return [start, end];
        }

        return pre;
      });
    }
  });
  useEffect(function () {
    updateScroll();
    var elem = ref.current;

    if (elem) {
      var listener = function listener(event) {
        if (event.target === elem) {
          updateScroll();
        }
      };

      elem.addEventListener('scroll', listener);
      return function () {
        return elem.removeEventListener('scroll', listener);
      };
    }
  }, [ref.current, size.clientWidth].concat(_toConsumableArray(deps)));
  return [ref, size, scrollStart, scrollEnd];
}

function getChildrenHeights(elem) {
  return Array.from(elem.children).map(function (child) {
    return child.offsetHeight;
  });
}

export function useTableCaptionsHeightInit(context) {
  var captionRef = useRef(null);
  var theadRef = useRef(null);
  var tbodyRef = useRef(null);
  var tfootRef = useRef(null);
  var refs = useConst({
    captionRef: captionRef,
    theadRef: theadRef,
    tbodyRef: tbodyRef,
    tfootRef: tfootRef
  });

  var _useState5 = useState({
    captionHeight: 0,
    theadHeights: [],
    tbodyHeights: [],
    tfootHeight: 0
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      contextValue = _useState6[0],
      setContextValue = _useState6[1];

  var updateContext = useConstCallback(function () {
    var captionElem = captionRef.current;
    var theadElem = theadRef.current;
    var tbodyElem = tbodyRef.current;
    var tfootElem = tfootRef.current;
    var captionHeight = captionElem && captionElem.offsetHeight || 0;
    var theadHeights = theadElem && getChildrenHeights(theadElem) || [];
    var tbodyHeights = tbodyElem && getChildrenHeights(tbodyElem) || [];
    var tfootHeight = tfootElem && tfootElem.offsetHeight || 0;
    setContextValue(function (pre) {
      if (captionHeight !== pre.captionHeight || !arrayEqual(theadHeights, pre.theadHeights) || !arrayEqual(tbodyHeights, pre.tbodyHeights) || tfootHeight !== pre.tfootHeight) {
        return {
          captionHeight: captionHeight,
          theadHeights: theadHeights,
          tbodyHeights: tbodyHeights,
          tfootHeight: tfootHeight
        };
      }

      return pre;
    });
  });
  useEffect(function () {
    updateContext();
    window.addEventListener('resize', updateContext);
    return function () {
      window.removeEventListener('resize', updateContext);
    };
  }, [context, captionRef.current, theadRef.current, tbodyRef.current, tfootRef.current]);
  return [refs, contextValue];
}
export var CaptionsHeightContext = createContext(undefined);
export var useTableCaptionsHeight = function useTableCaptionsHeight() {
  return useContext(CaptionsHeightContext);
};
var DEFAULT_MIN_WIDTH = 120;
var DEFAULT_MIN_WIDTH_RESIZE = 60;
var REGEX_PERCENTAGE = /^\d+(\.\d+)?%$/;
export function useTableColumnsWidthInit(containerClientWidth) {
  var columnsContext = useTableColumns();
  var columns = columnsContext.columns,
      leafColumns = columnsContext.leafColumns,
      resizable = columnsContext.resizable,
      setInnerColumns = columnsContext.setInnerColumns,
      innerColumns = columnsContext.innerColumns;

  var parseWidth = function parseWidth(value) {
    if (isNumber(value) && value > 0) {
      return Math.floor(value);
    }

    if (isString(value)) {
      var result = REGEX_PERCENTAGE.test(value) ? Math.floor(containerClientWidth * parseFloat(value) / 100) : Number.parseInt(value, 10);

      if (isNumber(result) && result > 0) {
        return result;
      }
    }

    return undefined;
  };

  var isMouseDown = useRef(false);
  var mouseDownClientX = useRef(0);
  var mouseDownColumnIndex = useRef(-1);
  var offsetXRef = useRef(0);

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      offsetX = _useState8[0],
      setOffsetX = _useState8[1];

  var calcWidth = function calcWidth(col, index) {
    var _a, _b, _c;

    var width = parseWidth(isNumber(col.width) && mouseDownColumnIndex.current === index + 1 ? col.width + offsetXRef.current : col.width);
    var minWidth = (_b = (_a = parseWidth(col.minWidth)) !== null && _a !== void 0 ? _a : width) !== null && _b !== void 0 ? _b : DEFAULT_MIN_WIDTH;
    var maxWidth = Math.max(minWidth, (_c = parseWidth(col.maxWidth)) !== null && _c !== void 0 ? _c : Number.POSITIVE_INFINITY);
    return {
      width: isNumber(width) ? clamp(width, minWidth, maxWidth) : width,
      minWidth: minWidth,
      maxWidth: maxWidth
    };
  };

  var resizeMouseUp = function resizeMouseUp(e) {
    if (isMouseDown.current) {
      isMouseDown.current = false;
      var resizabledWidth = calcWidth(innerColumns[mouseDownColumnIndex.current - 1], mouseDownColumnIndex.current - 1);
      var newColumnsCal = innerColumns.map(function (col, index) {
        return index === mouseDownColumnIndex.current - 1 ? _objectSpread(_objectSpread({}, col), {}, {
          width: resizabledWidth.width
        }) : _objectSpread({}, col);
      });
      setOffsetX(0);
      setInnerColumns(newColumnsCal);
    }
  };

  var resizeMouseDown = function resizeMouseDown(e, columnIndex) {
    isMouseDown.current = true;
    mouseDownClientX.current = e.clientX;
    mouseDownColumnIndex.current = columnIndex;
  };

  var resizeMouseMove = function resizeMouseMove(e) {
    if (isMouseDown.current) {
      var _offsetX = e.clientX - mouseDownClientX.current;

      var _columns = columns[mouseDownColumnIndex.current - 1],
          columnWidth = _columns.width,
          minWidth = _columns.minWidth;

      if ((parseWidth(columnWidth) || 0) + _offsetX >= (parseWidth(minWidth) || DEFAULT_MIN_WIDTH_RESIZE)) {
        setOffsetX(_offsetX);
        offsetXRef.current = _offsetX;
      }
    }
  };

  useEffect(function () {
    if (!resizable) return;
    window.addEventListener('mouseup', resizeMouseUp);
    window.addEventListener('mousemove', resizeMouseMove);
    return function () {
      window.removeEventListener('mouseup', resizeMouseUp);
      window.removeEventListener('mousemove', resizeMouseMove);
    };
  }, [innerColumns]);
  var leafColumnsWidthInfoMap = new Map();
  leafColumns.forEach(function (col, index) {
    var _a, _b, _c;

    var width = parseWidth(isNumber(col.width) && mouseDownColumnIndex.current === index + 1 ? col.width + offsetX : col.width);
    var minWidth = (_b = (_a = parseWidth(col.minWidth)) !== null && _a !== void 0 ? _a : width) !== null && _b !== void 0 ? _b : DEFAULT_MIN_WIDTH;
    var maxWidth = Math.max(minWidth, (_c = parseWidth(col.maxWidth)) !== null && _c !== void 0 ? _c : Number.POSITIVE_INFINITY);
    leafColumnsWidthInfoMap.set(col, {
      width: isNumber(width) ? clamp(width, minWidth, maxWidth) : width,
      minWidth: minWidth,
      maxWidth: maxWidth
    });
  });
  var totalMinWidth = leafColumns.reduce(function (total, col) {
    var _leafColumnsWidthInfo = leafColumnsWidthInfoMap.get(col),
        width = _leafColumnsWidthInfo.width,
        minWidth = _leafColumnsWidthInfo.minWidth;

    return total + (width !== null && width !== void 0 ? width : minWidth);
  }, 0);
  var tableMinWidth = Math.max(totalMinWidth, containerClientWidth);
  var contextValue = useMemo(function () {
    var scrollable = true;

    if (totalMinWidth < containerClientWidth) {
      scrollable = false;
      var totalRemainWidth = containerClientWidth;
      var needComputeWidthColumns = leafColumns.filter(function (col) {
        var widthInfo = leafColumnsWidthInfoMap.get(col);
        var width = widthInfo.width;

        if (isNumber(width)) {
          totalRemainWidth -= width;
          return false;
        }

        return true;
      });
      var averageWidth = totalRemainWidth / needComputeWidthColumns.length;
      needComputeWidthColumns = needComputeWidthColumns.filter(function (col) {
        var widthInfo = leafColumnsWidthInfoMap.get(col);
        var maxWidth = widthInfo.maxWidth;

        if (maxWidth < averageWidth) {
          widthInfo.width = maxWidth;
          totalRemainWidth -= maxWidth;
          return false;
        }

        return true;
      });
      averageWidth = totalRemainWidth / needComputeWidthColumns.length;
      needComputeWidthColumns = needComputeWidthColumns.filter(function (col) {
        var widthInfo = leafColumnsWidthInfoMap.get(col);
        var minWidth = widthInfo.minWidth;

        if (minWidth > averageWidth) {
          widthInfo.width = minWidth;
          totalRemainWidth -= minWidth;
          return false;
        }

        return true;
      });
      averageWidth = totalRemainWidth / needComputeWidthColumns.length;
      averageWidth = Math.floor(averageWidth);
      needComputeWidthColumns.forEach(function (col, index) {
        var widthInfo = leafColumnsWidthInfoMap.get(col);
        widthInfo.width = averageWidth;
        totalRemainWidth -= averageWidth;
      });

      if (totalRemainWidth) {
        var lastCol = lastItem(needComputeWidthColumns) || lastItem(leafColumns);

        if (lastCol) {
          leafColumnsWidthInfoMap.get(lastCol).width += totalRemainWidth;
        }
      }
    }

    var widthMap = new Map();
    {
      var getWidth = function getWidth(col) {
        var _a;

        var children = col.children;
        var width = 0;

        if (children) {
          width = children.reduce(function (total, child) {
            return total + getWidth(child);
          }, 0);
        } else {
          var widthInfo = leafColumnsWidthInfoMap.get(col);

          if (widthInfo) {
            width = (_a = widthInfo.width) !== null && _a !== void 0 ? _a : widthInfo.minWidth;
          }
        }

        widthMap.set(col, width);
        return width;
      };

      columns.forEach(function (col) {
        return getWidth(col);
      });
    }
    var stickyStartMap = new Map();
    {
      var process = function process(cols, parentValue) {
        var value = parentValue;

        for (var i = 0; i < cols.length; i++) {
          var col = cols[i];
          stickyStartMap.set(col, {
            value: value
          });
          col.children && process(col.children, value);
          value += widthMap.get(col);
        }
      };

      process(columns.filter(function (col) {
        return col.fixed === 'start';
      }), 0);
    }
    var stickyEndMap = new Map();
    {
      var _process = function _process(cols, parentValue) {
        var value = parentValue;

        for (var i = cols.length - 1; i > -1; i--) {
          var col = cols[i];
          stickyEndMap.set(col, {
            value: value
          });
          col.children && _process(col.children, value);
          value += widthMap.get(col);
        }
      };

      _process(columns.filter(function (col) {
        return col.fixed === 'end';
      }), 0);
    }
    return {
      containerInnerWidth: containerClientWidth,
      tableMinWidth: tableMinWidth,
      widthMap: widthMap,
      stickyStartMap: stickyStartMap,
      stickyEndMap: stickyEndMap,
      scrollable: scrollable,
      resizeMouseDown: resizeMouseDown
    };
  }, [columns, leafColumns, tableMinWidth, containerClientWidth, totalMinWidth]);
  return contextValue;
}
export var ColumnsWidthContext = createContext(undefined);
export var useTableColumnsWidth = function useTableColumnsWidth() {
  return useContext(ColumnsWidthContext);
};